'use strict';

/**
 * @ngdoc service
 * @name sharedModule.Document
 * @description
 * # Document
 * Service in the sharedModule.
 */

(function (angular, window, undefined) {
  var DocumentService = function ($document, $rootScope, $timeout) {
    'ngInject';//used by ng-annotate... must be first line in function

    this.checkFormIsValid = checkFormIsValid;

    function checkFormIsValid(form) {
      if (form.$invalid) {
        var invalid = touchAllInputs(form);
        if (invalid)
          $timeout(function () {
            setFocusByNameInForm(form.$name, invalid, true);
          }, 0);
        return false;
      }
      return true;
    }
    function touchAllInputs(form) {
      var invalids = [];
      angular.forEach(form, function (value, key) {
        if (angular.isObject(value) && '$setTouched' in value && !value.touched) {
          value.$setTouched();
          if (value.$invalid) {
            invalids.push(value.$name);
          }
        }
      });
      var firstCtl = findFirstControlByName(form, invalids);
      $rootScope.$broadcast(ExlConstants.events.touchAllInputs);
      return firstCtl;
    }

    function findFirstControlByName(form, ctlNames) {
      var selector = _getFormControlElementSelector(form.$name),
        controls = $document.find(selector).filter(function () {
          var ctrl = this;
          return ctlNames.indexOf(ctrl.getAttribute('name')) > -1;
        });
      if (controls.length) {
        return controls.attr('name');
      }
    }

    function setFocusByNameInForm(formName, name, scroll) {
      var selector = _getFormControlElementSelector(formName, name);
      _setFocus(selector, scroll);
    }

    function _setFocus(selector, scroll) {
      var elem = $document.find(selector);
      if (elem && elem.length) {
        elem[0].focus();
        if (scroll) {
          scrollToElem(elem);
        }
      }
    }
    function scrollToElem(element) {
      var topBarTotalHeight = 0;
      topBarTotalHeight += angular.element('[exl-sticky]').filter(function () {
        var jqEl = $(this);
        return !jqEl.hasClass('is_stuck')
          || (jqEl.css('position') === 'fixed'
            && parseFloat(jqEl.css('top')) === 0);
      }).outerHeight() || 0;
      topBarTotalHeight += angular.element('.top-bar').outerHeight() || 0;
      topBarTotalHeight += angular.element('.shortcut-bar').outerHeight() || 0;

      var fixedPositionHeaderOffset = (element.closest('.reveal-modal').length ? null : topBarTotalHeight) || 0,
        label = element.closest('label');
      if (!label.length) {
        if (element.is(':input')) {
          var id = element.attr('id');
          if (angular.isDefined(id)) {
            label = angular.element('label[for=' + id + ']');
          }
        } else if (element.is('exl-select-list')) {
          label = element.closest('exl-field-detail accordion').find('a:first');
        }
      }

      var offsetTop = label && label.length
        ? Math.min(element.offset().top, label.offset().top)
        : element.offset().top;
      $document.find('html,body').animate({
        // the 2 consecutive "~" characters perform 2 consecutive bitwise-NOT operations, having
        //  the same effect as Math.floor(), but a lot quicker and taking up fewer characters...
        scrollTop: ~~(offsetTop - fixedPositionHeaderOffset)
      }, "slow");
    }
    function _getFormControlElementSelector(formName, name) {
      var computedSelectors = [];

      _getFormControlSelectorArray(formName).forEach(function (currentValue) {
        var s = currentValue + " [name" + (angular.isString(name) ? "='" + name + "'" : "") + "]";
        this.push(s);
      }, computedSelectors);

      return computedSelectors.join(',');
    }

    function _getFormControlSelectorArray(formName) {
      var hasName = angular.isString(formName) && /\S+/.test(formName),
        attrSeparate = hasName ? "[name='" + formName + "']" : "",
        attrSame = hasName ? "='" + formName + "'" : "";
      return [
        "form" + attrSeparate,
        "ng-form" + attrSeparate,
        "[ng-form" + attrSame + "]",
        "[data-ng-form" + attrSame + "]"
      ];
    }
  };

  angular.module('sharedModule')
    .service('DocumentService', DocumentService);
})(angular, window);
